


window.addEventListener("load", (event) => {
  alert();
  setTimeout(() => {
  document.querySelector('.custom_chat_btn').addEventListener('click', function(e) {
  e.preventDefault(); // Prevents page jump
  const agentAvatar = document.querySelector('.embedded-agent-container .ai-agent-chat-avatar').click();
}, 2000);
  
    

});
});